var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResidentiPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 142,
    viewBox: "0 0 146 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.7472 138.971V129.802C93.7472 120.387 86.2107 112.826 76.9913 112.826H43.4795C34.187 112.826 26.7236 120.461 26.7236 129.802V138.971",
    stroke: "#2B318A",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9903 78.8779C76.9903 88.2923 69.4538 95.8535 60.2344 95.8535C51.015 95.8535 43.4785 88.2182 43.4785 78.8779C43.4785 69.5376 51.015 61.9023 60.2344 61.9023C69.4538 61.9023 76.9903 69.5376 76.9903 78.8779Z",
    stroke: "#2B318A",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M118.844 138.973V129.803C118.844 122.094 113.649 115.348 106.259 113.421",
    stroke: "#2B318A",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5029 62.4941C98.5028 64.8663 103.844 74.0583 101.576 83.1762C100.039 89.1806 95.4297 93.8507 89.5029 95.4075",
    stroke: "#2B318A",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 67.8904L65.0133 6.84738C69.7859 2.16285 77.4954 2.16285 82.3413 6.84738L142.622 66.0166",
    stroke: "#2B318A",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResidentiPurple);
export default __webpack_public_path__ + "static/media/residentiPurple.2e41080b573105ef0d9badb5fbeb0bc5.svg";
export { ForwardRef as ReactComponent };